import React, { useState } from 'react';
import { institutions } from './institutionsData';

const ApplyButton = ({ url }) => {
  const isDisabled = !url;

  return (
    <a
      href={url || '#'}
      onClick={e => {
        if (isDisabled) e.preventDefault();
      }}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        padding: '12px 28px',
        borderRadius: 8,
        background: isDisabled ? '#ccc' : '#a05a2c',
        color: isDisabled ? '#666' : '#fff',
        fontWeight: 700,
        fontSize: 18,
        textDecoration: 'none',
        pointerEvents: isDisabled ? 'none' : 'auto',
        cursor: isDisabled ? 'default' : 'pointer',
        userSelect: 'none',
        transition: 'background-color 0.3s',
      }}
      aria-disabled={isDisabled}
      tabIndex={isDisabled ? -1 : 0}
      title={isDisabled ? "No application URL available for this institution" : "Apply Now"}
    >
      Apply Now
    </a>
  );
};

const Institutions = () => {
  const [search, setSearch] = useState('');
  const topTen = institutions.slice(0, 10);
  const filtered = search.trim()
    ? institutions.filter(inst => inst.name.toLowerCase().includes(search.toLowerCase()))
    : topTen;

  return (
    <div style={{ maxWidth: 700, margin: '40px auto', padding: 24 }}>
      <h1
        style={{
          color: '#fff',
          fontSize: 32,
          fontWeight: 700,
          marginBottom: 8,
          marginTop: 0,
          textShadow: '0 2px 8px #0007',
        }}
      >
        Institutions Open for Application
      </h1>
      <input
        type="text"
        aria-label="Search institutions"
        placeholder="Search for an institution..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{
          width: '100%',
          padding: 12,
          borderRadius: 8,
          border: '1px solid #c7a16c',
          margin: '24px 0',
          fontSize: 18,
          boxSizing: 'border-box',
        }}
      />
      <div
        style={{
          color: '#fff',
          fontSize: 16,
          marginBottom: 32,
          textShadow: '0 2px 8px #0007',
        }}
      >
        <b>Note:</b> Only the top 10 South African institutions are listed. If you don’t see your institution, it
        may not be in this list yet.
      </div>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {filtered.length === 0 && (
          <li style={{ color: '#888', marginTop: 32 }}>No institutions found.</li>
        )}
        {filtered.map(inst => (
          <li
            key={inst.name}
            style={{
              marginBottom: 28,
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 2px 12px #eee',
              padding: 24,
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
            }}
          >
            <div style={{ flex: '1 1 auto', minWidth: 0 }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 22,
                  color: '#2d4b2d',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                title={inst.name}
              >
                {inst.name}
              </div>
              <div
                style={{
                  fontSize: 16,
                  color: '#a05a2c',
                  marginTop: 4,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                title={inst.type}
              >
                {inst.type}
              </div>
            </div>
            <ApplyButton url={inst.applyUrl} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Institutions;
